var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnbox2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 170,
    viewBox: "0 0 337 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9043 0.464844H306.448C315.73 0.464844 323.455 7.59323 324.2 16.8447L334.937 150.173C335.775 160.582 327.518 169.476 317.075 169.412L19.8838 167.575C9.45764 167.511 1.3163 158.543 2.25684 148.159L14.168 16.668C14.9991 7.49232 22.6911 0.464932 31.9043 0.464844Z",
    fill: "#FBF5E3",
    stroke: "black",
    strokeWidth: 0.93
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8438 58L327.107 58",
    stroke: "#FFA400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnbox2);
export default __webpack_public_path__ + "static/media/btnbox2.503ac4b3a93df14629561afd60bd28f3.svg";
export { ForwardRef as ReactComponent };